module.exports = __webpack_public_path__ + "static/media/icon-mouse.e6f73235.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icon-mouse.svg
// module id = 335
// module chunks = 0